$(window).on('load', function () {
  $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {
    quickView();
  });
});

function quickView() {

  $('.quick-add').on('click', function() {
    jQuery.post('/cart/add.js', {
        quantity: 1,
        id: $(this).data('sku')
      },
      null,
      "json"
     ).done(function () {
        $('#sidebar-cart').empty().load('/cart?view=' + 'drawer' + '&timestamp=' + Date.now()+ ' #sidebar-cart__content', function( response, status, xhr ) {
          if(status == 'success') {
            jQuery('.PageOverlay').addClass('is-visible');
            jQuery('#sidebar-cart').attr("aria-hidden","false");
            jQuery('.Header__CartDot').addClass('is-visible');
            setTimeout(function() {
              jQuery('.PageOverlay').removeClass('is-visible');
              jQuery('#sidebar-cart').attr("aria-hidden","true");
            }, 2000);
          }
        });

      })
      .fail(function ($xhr) {
        var data = $xhr.responseJSON;
        console.log(data.description);
      });

  });
function preHandleProduct(product) {
        return Promise.resolve(product);
    }
  $(".quick-view").click(function () {
    if ($('#quick-view').length == 0){$("body").append('<div id="quick-view"></div>');}
    var product_handle = $(this).data('handle');
    $('#quick-view').addClass(product_handle);
    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
      preHandleProduct(product)
      .then(function(product){
        if ((JSON.stringify(product.tags).indexOf("__label:Pre-Order") >= 0)) {
          $('.qv-add-button').val('Pre-Order');
        }
        var title = product.title;
        var url = product.url;
        var price = 0;
        var original_price = 0;
        // var desc = product.description;
        var featuredImage = product.featured_image;
        // var sku = product
        var variants = product.variants;
        var options = product.options;
        var url = '/products/' + product_handle;
        $('.qv-product-title').text(title);
        $('.modify__button').attr("href", "https://b2b.shycreation.com" + url + "/?modify=true");
        // $('.qv-product-type').text(type);
        $('.view-product').attr('href', url);
        $('.qv-product-image').attr('src', featuredImage);
        $(options).each(function (i, option) {
          var opt = option.name;
          var optLower = option.name.toLowerCase();
          var selectClass = '.option.' + opt.toLowerCase();
          if(optLower == 'color') {
            $('.qv-product-options').append('<div class="option-selection option-selection-' + opt.toLowerCase() + '"><span class="ProductForm__Label">' + opt + ':</span>'+
                                            '<div class="ProductItem__ColorSwatchList">' +
                                            '<select class="option-' + i + ' option ' + opt.toLowerCase() + '"></select></div>');
          } else {
            $('.qv-product-options').append('<div class="option-selection option-selection-' + opt.toLowerCase() + '"><span class="ProductForm__Label">' + opt + ':</span><select class="option-' + i + ' option ' + opt.toLowerCase() + '"></select></div>');
          }
          $(option.values).each(function (i, value) {
            if(optLower == 'color') {
              if(i == 0) {
                $('#quick-view .ProductItem__ColorSwatchList').append('<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch active ColorSwatch--'+value.toLowerCase()+'" style="background-image:url(//b2b.shycreation.com/cdn/shop/t/21/assets/'+value.toLowerCase()+'_64x64.png?v=14816);background-color: '+value.toLowerCase()+'; " title="'+value+'" data-index="'+i+'" data-tooltip="'+value+'"></label></div>')
              } else {
                $('#quick-view .ProductItem__ColorSwatchList').append('<div class="ProductItem__ColorSwatchItem"><label class="ColorSwatch ColorSwatch--'+value.toLowerCase()+'" style="background-image:url(//b2b.shycreation.com/cdn/shop/t/21/assets/'+value.toLowerCase()+'_64x64.png?v=14816);background-color: '+value.toLowerCase()+'; " title="'+value+'" data-index="'+i+'" data-tooltip="'+value+'"></label></div>')
              }
            }
            $('.option.' + opt.toLowerCase()).append('<option value="' + value + '">' + value + '</option>');
          });
        });
        $(product.variants).each(function (i, v) {
          $('.qv-product-sku').text(v.sku);
          if (v.inventory_quantity == 0) {
            $('.qv-add-button').prop('disabled', true).val('Sold Out');
            $('.qv-add-to-cart').hide();
            $('.qv-product-price').text('Sold Out').show();
            return true
          } else {
            price = parseFloat(v.price / 100);
            original_price = parseFloat(v.compare_at_price / 100);
            $('.qv-product-price').text('$' + price);
            if (original_price > 0) {
              $('.qv-product-original-price').text('$' + original_price).show();
            } else {
              $('.qv-product-original-price').hide();
            }
            $('select.option-0').val(v.option1);
            $('select.option-1').val(v.option2);
            $('select.option-2').val(v.option3);
            return false
          }
        });
        $('.QuantitySelector__Button').on('click', function() {
          if($(this).data('action') == 'increase-quantity') {
            $('.qv-quantity').val(parseInt($('.qv-quantity').val()) + 1);
          }
          if($(this).data('action') == 'decrease-quantity') {
            if($('.qv-quantity').val() > 1) {
              $('.qv-quantity').val(parseInt($('.qv-quantity').val()) - 1);
            }
          }
        });
        $('.ColorSwatch').on('click', function() {
          $('.ColorSwatch').removeClass('active');
          $(this).addClass('active');
          $('.option.color option:eq('+$(this).data('index')+')').prop('selected', true);
        });
      });
    });

    $(document).on("change", "#quick-view select", function () {
      var selectedOptions = '';
      $('#quick-view select').each(function (i) {
        if (selectedOptions == '') {
          selectedOptions = $(this).val();
        } else {
          selectedOptions = selectedOptions + ' / ' + $(this).val();
        }
      });
      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
        preHandleProduct(product).then(function(product){
          $(product.variants).each(function (i, v) {
            if (v.title == selectedOptions) {
              var price = parseFloat(v.price / 100).toFixed(2);
              var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
              var v_qty = v.inventory_quantity;
              var v_inv = v.inventory_management;
              $('.qv-product-price').text('$' + price);
              $('.qv-product-original-price').text('$' + original_price);
              if (v_inv == null) {
                $('.qv-add-button').prop('disabled', false).val('Add to Cart');
              } else {
                if (v.inventory_quantity < 1) {
                  $('.qv-add-button').prop('disabled', true).val('Sold Out');
                } else {
                  $('.qv-add-button').prop('disabled', false).val('Add to Cart');
                }
              }
            }
          });
        });
      });
    });
    $.fancybox({
      href: '#quick-view',
      maxWidth: 1040,
      maxHeight: 700,
      fitToView: true,
      width: '85%',
      height: '80%',
      autoSize: false,
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none',
      'beforeLoad': function () {
        var product_handle = $('#quick-view').attr('class');
        $(document).on("click", ".qv-add-button", function () {
          var qty = $('.'+product_handle+' .qv-quantity').val();
          var selectedOptions = '';
          var var_id = '';
          $('#quick-view.'+product_handle+' select').each(function (i) {
            if (selectedOptions == '') {
              selectedOptions = $(this).val();
            } else {
              selectedOptions = selectedOptions + ' / ' + $(this).val();
            }
          });
          jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
            $(product.variants).each(function (i, v) {
              if (v.title == selectedOptions) {
                var_id = v.id;
                processCart();
              }
            });
          });
          function processCart() {
            jQuery.post('/cart/add.js', {
              quantity: qty,
              id: var_id
            },
            null,
            "json"
           ).done(function () {
              $('#sidebar-cart').empty().load('/cart?view=' + 'drawer' + '&timestamp=' + Date.now()+ ' #sidebar-cart__content', function( response, status, xhr ) {
                $.fancybox.close();
                if(status == 'success') {
                  jQuery('.PageOverlay').addClass('is-visible');
                  jQuery('#sidebar-cart').attr("aria-hidden","false");
                  jQuery('.Header__CartDot').addClass('is-visible');
                  setTimeout(function() {
                    jQuery('.PageOverlay').removeClass('is-visible');
                    jQuery('#sidebar-cart').attr("aria-hidden","true");
                  }, 2000);
                }
              });

            })
            .fail(function ($xhr) {
              var data = $xhr.responseJSON;
              console.log(data.description);
            });
          }
        });
        $('.fancybox-wrap').css('overflow', 'hidden !important');
      },
      'afterShow': function () {
        $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
          $('.qv-product-images').addClass('loaded');
        });
      },
      'afterClose': function () {
        $('#quick-view').removeClass().empty();
      }
    });
  });
};
